import { render, staticRenderFns } from "./ProductSerialNumbers.vue?vue&type=template&id=4f5fcbb2"
import script from "./ProductSerialNumbers.vue?vue&type=script&lang=js"
export * from "./ProductSerialNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports